Array.prototype.equals && console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code."), Array.prototype.equals = function (e) { if (!e) return !1; if (this.length != e.length) return !1; for (var r = 0, t = this.length; r < t; r++)if (this[r] instanceof Array && e[r] instanceof Array) { if (!this[r].equals(e[r])) return !1 } else if (this[r] != e[r]) return !1; return !0 }, Object.defineProperty(Array.prototype, "equals", { enumerable: !1 });
var jsonProduct = null;
function httpGetAsync(theUrl)
{
  return new Promise(function (resolve, reject) {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.onreadystatechange = function() { 
          if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
             resolve(xmlHttp.response);
      }
      xmlHttp.open("GET", theUrl, true); // true for asynchronous 
      xmlHttp.send(null);
  })
}

var observeDOM = (function(){
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  
    return function( obj, callback ){
      if( !obj || obj.nodeType !== 1 ) return; 
  
      if( MutationObserver ){
        // define a new observer
        var mutationObserver = new MutationObserver(callback)
  
        // have the observer observe foo for changes in children
        mutationObserver.observe( obj, { childList:true, subtree:false })
        return mutationObserver
      }
      
      // browser support fallback
      else if( window.addEventListener ){
        obj.addEventListener('DOMNodeInserted', callback, false)
        obj.addEventListener('DOMNodeRemoved', callback, false)
      }
    }
  })()

//Product sell out function
async function updateSoldOutItems(){
  var jsonProductData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  var jsonProductOptions = jsonProductData.product['options'];
  var jsonProductHandle = jsonProductData.product['handle'];

  if(jsonProduct === null){
    try{
      jsonProduct = await httpGetAsync(`${window.Shopify.routes.root}products/${jsonProductHandle}.js`);
      jsonProduct = JSON.parse(jsonProduct);
    }catch(err){
      console.log(err)
    }
  }

  let optionSelectables = document.querySelectorAll('.ProductForm__Option');

  function applyDisabled(querySelector, index, isAvail, hasAvail){
    let labelSelector = `ul li.HorizontalList__Item:nth-child(${index+1}) label`;
    querySelector.querySelector(labelSelector).classList.toggle("soldout", false);

    if(!hasAvail && !isAvail){
      querySelector.querySelector(labelSelector).classList.toggle("soldout", true);
    }

    if(!hasAvail && isAvail){
      querySelector.querySelector(labelSelector).classList.toggle("soldout", true);
    }

    if(!isAvail){
      querySelector.querySelector(labelSelector).classList.toggle("soldout", true);
    }
  }

  if(jsonProductOptions && jsonProductOptions[0]){
    var selectOption0 = document.querySelectorAll('.SizeSwatch__Radio:checked')[0].value;
    jsonProduct["options"][0]["values"].forEach((value, valueIndex) => {
      let oneAvailable = jsonProduct['variants'].some((variantData) => variantData['option1'] === value && variantData);
      let hasAvailable = jsonProduct['variants'].some((variantData) => variantData['option1'] === value && variantData["available"]);
      applyDisabled(optionSelectables[0], valueIndex, oneAvailable, hasAvailable);
    });
  }

  if(jsonProductOptions[1]){
    var selectOption1 = document.querySelectorAll('.SizeSwatch__Radio:checked')[1].value;
    jsonProduct["options"][1]["values"].forEach((value2, valueIndex2) => {
      let oneAvailable2option = jsonProduct['variants'].some((variantData) => variantData['option2'] === value2 && variantData['option1'] === selectOption0 && variantData);
      let hasAvailable2option = jsonProduct['variants'].some((variantData) => variantData['option2'] === value2 && variantData['option1'] === selectOption0 && variantData['available']);
      applyDisabled(optionSelectables[1], valueIndex2, oneAvailable2option, hasAvailable2option);
    });
  }

  if(jsonProductOptions[2]){
    var selectOption2 = document.querySelectorAll('.SizeSwatch__Radio:checked')[2].value;
    jsonProduct["options"][2]["values"].forEach((value3, valueIndex3) => {
      let oneAvailable3option = jsonProduct['variants'].some((variantData) => variantData['option3'] === value3 && variantData['option2'] === selectOption1 && variantData['option1'] === selectOption0 && variantData);
      let hasAvailable3option = jsonProduct['variants'].some((variantData) => variantData['option3'] === value3 && variantData['option2'] === selectOption1 && variantData['option1'] === selectOption0 && variantData['available']);
      applyDisabled(optionSelectables[2], valueIndex3, oneAvailable3option, hasAvailable3option);
    });
  }
}

/* Page redirects */
if(window.location.href.includes('option-set-283635-buttons-6')){
  window.location.replace('https://www.switchkeys.com.au/collections/keyboards/products/option-set-283635-buttons-1');
}

if(window.location.href.includes('option-set-283635-buttons-3')){
  window.location.replace('https://www.switchkeys.com.au/collections/keyboards/products/option-set-283635-buttons-1');
}


if(window.location.href.includes('option-set-302862-buttons-2')){
  window.location.replace('https://www.switchkeys.com.au/products/class60-keyboard-group-buy');
}

if(window.location.href.includes('option-set-302862-buttons-1')){
  window.location.replace('https://www.switchkeys.com.au/products/class60-keyboard-group-buy');
}



/* Page redirects End */



function groupbuyApproval() {
    if (window.location.href.includes('products')) {
        let productTitle = document.querySelector('h1.ProductMeta__Title.Heading.u-h2').innerText;
        if (productTitle.toLowerCase().includes('group buy') || productTitle.toLowerCase().includes('pre-order')) {
            var cartForm = document.querySelector('form[action="/cart/add"]');
            var addtocartButton = cartForm.getElementsByClassName('ProductForm__AddToCart')[0];

            addtocartButton.disabled = true;
            addtocartButton.removeAttribute('data-action');

            let checkboxNode = document.createElement("p");
            checkboxNode.innerHTML = `
                <p style="float: none; clear: both; margin: 10px 0; text-indent: -1.2em; padding-left: 1em;">
                <input style="float:none; vertical-align: middle;" type="checkbox" id="agree" />
                <label style="display:inline; float:none;" for="agree">
                    The following Group Buy/Pre-Order is not an in-stock product. 
                    <br />
                    100% pre-paid deposit required. No cancellations are accepted once the purchase window for this Group Buy has concluded.
                    <br />
                    By purchasing, you agree to our 
                    <a href="https://www.switchkeys.com.au/pages/returns-policy" target="_blank" style="text-decoration: underline; color: #fff;">Terms and Conditions</a> 
                    and understand our <a href="https://www.switchkeys.com.au/pages/what-is-a-group-buy" target="_blank" style="text-decoration: underline; color: #fff;">Group Buy</a> 
                    process, including the expected ETA for this product and any potential delays, that cancellations are not permitted, and that combining orders is not possible.
                </label>
                </p>
            `;
            cartForm.insertBefore(checkboxNode, addtocartButton)

            var agreeCheckbox = document.getElementById('agree');

            agreeCheckbox.addEventListener('change', function () {
                if (this.checked && addtocartButton.innerText.toLowerCase().trim() == "add to cart") {
                    addtocartButton.disabled = false;
                    addtocartButton.setAttribute('data-action', "add-to-cart");
                    //addtocartButton.addEventListener("click", isoVariant);
                } else {
                    addtocartButton.disabled = true;
                    addtocartButton.removeAttribute('data-action');
                    //addtocartButton.removeEventListener("click", isoVariant);
                }
            });

            document.addEventListener("variant:changed", function () {
                if (agreeCheckbox.checked && addtocartButton.innerText.toLowerCase().trim() == "add to cart") {
                    addtocartButton.disabled = false;
                    addtocartButton.setAttribute('data-action', "add-to-cart");
					
                } else {
                    addtocartButton.disabled = true;
                    addtocartButton.removeAttribute('data-action');
                }
            });
        }
    }
}

/*
  function isoVariant(e){
    var cartForm = document.querySelector('form[action="/cart/add"]');
    var addtocartButton = cartForm.getElementsByClassName('ProductForm__AddToCart')[0];
    
    if(window.location.href.includes("44108165710117")){
      alert("Are you sure you want to purchase an ISO PCB? If no, please remove it from your cart and select ANSI");
    }
  }
*/

window.addEventListener('load', function () {
    if (window.location.href.includes('products')) {
        updateSoldOutItems();
        groupbuyApproval();
        document.addEventListener("variant:changed", updateSoldOutItems);
    }
});

observeDOM(document.getElementById('sidebar-cart'), function (m) {
    //carterror();
});

observeDOM(document.querySelector('.PageContent'), function (m) {
    //carterror();
});

if (window.location.href.includes('cart')) {
    //carterror();
}

/*
function carterror() {
    var products = new Array();
    var productsVariant = new Array();

    var cartfooter = document.querySelector('form[action="/cart"] > .Cart__Footer');
    var drawerfooter = document.querySelector('.Cart.Drawer__Content > .Drawer__Footer');
    var productButton = document.querySelector('[data-shopify="payment-button"]');
    var checkoutButton = document.querySelector('[name="checkout"]');
    var diverror = document.createElement('div');
    diverror.style.color = '#fff';
    diverror.style.backgroundColor = "#cc0000";
    diverror.style.margin = "auto";
    diverror.style.padding = '20px';
    diverror.style.width = '100%';

    var productDOM = document.querySelectorAll('h2.CartItem__Title a');
    var productDOMVariant = document.querySelectorAll('p.CartItem__Variant');

    for (let i = 0; i < productDOM.length; i++) {
        products.push(productDOM[i].innerHTML);
        if(productDOMVariant[i]) productsVariant.push(productDOMVariant[i].innerHTML);
    }

    var groupbuy = false;
    var groupbuyitem = "";

    var preorder = false;
    var preorderitem = "";

    var keychron = false;
    
  	var qkItems = [];
    var isQK65Complete = false;
  	var qkError = false;
    var qkBundle = false;
  
  	var qkCase = false;
  
    const isAllSameGroupBuy = (productitemname) => productitemname.toLowerCase().includes(groupbuyitem);
    const isAllSamePreOrder = (productitemname) => productitemname.toLowerCase().includes(preorderitem);

    for (let i = 0; i < products.length; i++) {
        if (products[i].toLowerCase().includes('group buy')) {
            groupbuy = true;
            groupbuyitem = products[i].toLowerCase().split('-')[0].trim();
          	if(groupbuyitem.toLowerCase().includes('group buy')){
              groupbuyitem = groupbuyitem.toLowerCase().split('(group buy)')[0].trim();
            }
        }

        if (products[i].toLowerCase().includes('pre-order')) {
            preorder = true;
            preorderitem = products[i].toLowerCase().split('-')[0].trim();
            if(preorderitem.toLowerCase().includes('(pre')){
              preorderitem = preorderitem.toLowerCase().split('(pre')[0].trim();
            }
            if(preorderitem.toLowerCase().includes('keychron')){
              keychron = true;
            }
        }
      
      	if (products[i].toLowerCase().includes('qk60 r2')) {
            if(products[i].toLowerCase() === "qwertykeys qk60 r2 - keyboard (pre-order)"){
                qkCase = true;
            }

          	qkItems.push(products[i].toLowerCase());
        }
    }
  
    if (groupbuy || preorder){
        diverror.innerHTML = `
            <p style="text-align: center; font-weight: bold; font-size: 18px;">Oops!!! There is an error with your cart.</p>
            <p>Group buy and pre-order items can only be purchased with other items from the SAME group buy or pre-order and 
            can NOT be purchased in the same transaction as in-stock items. </p>
            <p style="text-align: center; font-weight: bold;">Please purchase these items in separate transactions. Thanks, SK Management.</p>
        `;
    }
  
    if(qkCase){
      	let qkList = [];
        if(qkItems.length >= 2){
            for(let i = 0; i < qkItems.length; i++){
              console.log(qkItems[i]);
              if(qkItems[i] === "qwertykeys qk60 r2 - plates (pre-order)"){
                if(qkList.includes('cub65 - plates') == false) qkList.push('cub65- plates')
              }
              if(qkItems[i] === "qwertykeys qk60 r2 - pcbs (pre-order)"){
                if(qkList.includes('cub65 - pcbs') == false) qkList.push('cub65 - pcbs')
              }
            }
        }
        
        if(qkList.length < 2){
			diverror.innerHTML = `
            <p style="text-align: center; font-weight: bold; font-size: 18px;">Oops!!! There is an error with your cart.</p>
            <p>You will need to have a QK60 R2 case, PCB and Plate in your cart to check out. Please check your cart and try again. 
				We also do not allow mixing of pre-order and in-stock products</p>
            <p style="text-align: center; font-weight: bold;">Thanks, SK Management.</p>
        `;
          	qkError = true;
        }
    }

    if(groupbuy && preorder){
        if(checkoutButton) {
            document.querySelector('[name="checkout"]').disabled = true;
        }
        if(productButton) {
            document.querySelector('[data-shopify="payment-button"]').style.visibility = "hidden";
        }
        if (drawerfooter) {
            drawerfooter.parentNode.insertBefore(diverror, drawerfooter);
        }
        if (cartfooter) {
            cartfooter.parentNode.insertBefore(diverror, cartfooter);
        }
    } else if (groupbuy) {
        if (!products.every(isAllSameGroupBuy)) {
            if(checkoutButton) {
                document.querySelector('[name="checkout"]').disabled = true;
            }
            if(productButton) {
                document.querySelector('[data-shopify="payment-button"]').style.visibility = "hidden";
            }
            if (drawerfooter) {
                drawerfooter.parentNode.insertBefore(diverror, drawerfooter);
            }
            if (cartfooter) {
                cartfooter.parentNode.insertBefore(diverror, cartfooter);
            }
        } else {
            if(checkoutButton) {
                document.querySelector('[name="checkout"]').disabled = false;
            }
            if(productButton) {
                document.querySelector('[data-shopify="payment-button"]').style.visibility = "visible";
            }
        }
    } else if (preorder && !qkError && !keychron) {
        if (!products.every(isAllSamePreOrder)) {
            if(checkoutButton) {
                document.querySelector('[name="checkout"]').disabled = true;
            }
            if(productButton) {
                document.querySelector('[data-shopify="payment-button"]').style.visibility = "hidden";
            }
            if (drawerfooter) {
                drawerfooter.parentNode.insertBefore(diverror, drawerfooter);
            }
            if (cartfooter) {
                cartfooter.parentNode.insertBefore(diverror, cartfooter);
            }
        } else {
            if(checkoutButton) {
                document.querySelector('[name="checkout"]').disabled = false;
            }
            if(productButton) {
                document.querySelector('[data-shopify="payment-button"]').style.visibility = "visible";
            }
        }
    } else if (qkError){ 
        if(checkoutButton) {
          document.querySelector('[name="checkout"]').disabled = true;
        }
        if(productButton) {
          document.querySelector('[data-shopify="payment-button"]').style.visibility = "hidden";
        }
        if (drawerfooter) {
          drawerfooter.parentNode.insertBefore(diverror, drawerfooter);
        }
        if (cartfooter) {
          cartfooter.parentNode.insertBefore(diverror, cartfooter);
        }
    } else {
        if(checkoutButton) {
            document.querySelector('[name="checkout"]').disabled = false;
        }
        if(productButton) {
            document.querySelector('[data-shopify="payment-button"]').style.visibility = "visible";
        }
    }
}
*/
